import { FacebookMini, Instagram, Twitter } from 'src/components/elements/Icons';

import { AboutUsCard } from 'src/types';

export const ANCHOR_KEY = 'anchor';

export const AboutTextFirstLines = [
  {
    id: 'firstLine1',
    text: 'hear',
  },
  {
    id: 'firstLine2',
    text: 'identify',
  },
  {
    id: 'firstLine3',
    text: 'anticipate',
  },
  {
    id: 'firstLine4',
    text: 'save',
  },
  {
    id: 'firstLine5',
    text: 'expand',
  },
  {
    id: 'firstLine6',
    text: 'build',
  },
];

export const AboutTextSecondLines = [
  {
    id: 'secondLine1',
    text: 'our customers',
  },
  {
    id: 'secondLine2',
    text: 'their vision',
  },
  {
    id: 'secondLine3',
    text: 'their needs',
  },
  {
    id: 'secondLine4',
    text: 'their time',
  },
  {
    id: 'secondLine5',
    text: 'their horizons',
  },
  {
    id: 'secondLine6',
    text: 'a new travel universe',
  },
];

export const CardsData: AboutUsCard[] = [
  {
    id: 'card_1',
    label: 'Search',
    title: 'It&rsquo;s smart',
    text: 'Solartrip&rsquo;s unparalleled selection of&nbsp;worldwide stays and flights fused with advanced software search options expands the horizons of&nbsp;your travel possibilities making every experience unique',
    y2: -20,
    mobileY2: -50,
  },
  {
    id: 'card_2',
    label: 'Payment',
    title: 'It&rsquo;s easy',
    text: 'At&nbsp;Solartrip, we&nbsp;offer the flexibility to&nbsp;pay in&nbsp;a&nbsp;way that suits you best, with our wide range of&nbsp;accepted payment methods, including pays, cards, and cryptocurrencies',
    y1: -370,
    y2: -500,
    mobileY1: -380,
    mobileY2: -480,
  },
  {
    id: 'card_3',
    label: 'Support',
    title: 'It&rsquo;s instant',
    text: 'The immediate and effective AI-powered customer care helps Solartrip build a&nbsp;stronger and reliable relationship with our major co-creators&nbsp;&mdash; our clients',
    y1: -850,
    y2: -980,
    mobileY1: -812,
    mobileY2: -912,
  },
  {
    id: 'card_4',
    label: 'Loyalty',
    title: 'It&rsquo;s cosmic',
    text: 'Your travels are unique, just like the cosmic loyalty rewards you earn exploring the world with Solartrip',
    y1: -1330,
    mobileY1: -1240,
  },
];

export const EMAILS = [
  {
    id: 'media',
    link: 'media@solartrip.com',
  },
  {
    id: 'support',
    link: 'support@solartrip.com',
  },
];
export const SOCIAL_LINKS = [
  {
    id: 'facebook',
    icon: FacebookMini(),
    link: 'https://www.facebook.com/solartripcom',
  },
  {
    id: 'instagram',
    icon: Instagram(),
    link: 'https://www.instagram.com/solartripcom',
  },
  {
    id: 'twitter',
    icon: Twitter(),
    link: 'https://twitter.com/Solartripcom',
  },
];
